<template>
    <div class="card-body p-30">
        <div :key="index" class="row" v-for="index in Math.ceil(did_records.length/2)">
            <div class="col-sm-12 col-lg-6">
                <div class="form-group row" v-if="did_records[(index-1)*2]">
                    <label class="col-sm-5 control-label">{{did_records[(index-1)*2].name}}</label>
                    <div class="col-sm-7">
                        <p class="form-control-static"
                           v-if="did_records[(index-1)*2].name.toLowerCase().indexOf('location') === -1">
                            {{did_records[(index-1)*2].fact.value}}</p>
                        <a :href="'https://www.google.com/maps/search/'+did_records[(index-1)*2].fact.value.replace(';', ',')"
                           target="_blank" v-else>View on Map</a>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-lg-6">
                <div class="form-group row" v-if="did_records[(index-1)*2+1]">
                    <label class="col-sm-5 control-label">{{did_records[(index-1)*2+1].name}}</label>
                    <div class="col-sm-7">
                        <p class="form-control-static"
                           v-if="did_records[(index-1)*2+1].name.toLowerCase().indexOf('location') === -1">
                            {{did_records[(index-1)*2+1].fact.value}}</p>
                        <a :href="'https://www.google.com/maps/search/'+did_records[(index-1)*2+1].fact.value.replace(';', ',')"
                           target="_blank" v-else>View on Map</a>
                    </div>
                </div>
            </div>
        </div>
        <h6 class="card-title mt-3 mb-3" v-if="did_attachments.length > 0">DID
            Attachments</h6>
        <b-table :busy="busy" :current-page="currentPage" :fields="fields"
                 :items="did_attachments"
                 :per-page="perPage"
                 :sort-by="sortBy"
                 :sort-desc="sortDesc" :sort-direction="sortDirection" responsive striped
                 tbody-tr-class="rowClass" v-if="did_attachments.length > 0">
            <template #cell(hash)="data">{{data.value | hex_format(10, '....')}}</template>
            <template #cell(created)="data">{{ data.value | date }}</template>
            <template #cell(download)="data">
                <a @click="downloadAttachment(data)" class="text-inverse"
                   data-original-title="Download" data-toggle="tooltip"
                   href="javascript:void(0)" title=""><i
                        class="fa fa-download fa-border"></i></a>
            </template>
        </b-table>
    </div>
</template>

<script>
    export default {
        name: "PersonalInfoTab",
        props: ['did_records', 'memberid', 'did_attachments'],
        data() {
            return {
                fields: [
                    {
                        key: 'property_name',
                        label: 'Name',
                    },
                    {
                        key: 'name',
                        label: 'File Name',
                        sortable: true
                    },
                    {
                        key: 'hash',
                        label: 'File Hash'
                    },
                    {
                        key: 'created',
                        label: 'Created on',
                    },
                    {
                        key: 'download',
                        label: 'Action',
                    }
                ],
                busy: false,
                currentPage: 1,
                perPage: 5,
                totalRows: 0,
                sortBy: 'name',
                sortDesc: false,
                sortDirection: 'asc',
            }
        },
        methods: {
            async downloadAttachment(attachment) {
                let reply = await this.$identity.get(`identity/dids/${this.memberid}/documents/${attachment.item.id}`);
                let link = document.createElement('a');
                link.href = 'data:application/octet-stream;base64,' + reply.data;
                link.download = attachment.item.name;
                link.click();
            },
        }
    }
</script>

<style scoped>

</style>
